let LoadingCheckoutLibs = false;

$('.helen-checkout-parent').each(/** @this {Element} */ function () {
	let FirstCartItemAdded = false;
	let ClassicForm = false;

	const $main = $(this);
	$main.parent().css({'overflow': 'hidden'});
    const HelenCheckoutID = /** @type {string} */ ($main.attr('data-helen-checkout-id'));

    /**
     * @param {!jQuery} $scope
     */
    const cartControlsInit = function ($scope) {
        $scope.find('[data-toggle="popover"]').popover({
            'trigger': 'manual',
            'animation': false,
        }).on('mouseenter', /** @this {Element} */ function () {
            const $this = $(this);
            $this.popover("show");
            $('.popover').on('mouseleave', function () {
                $this.popover('hide');
            });
        }).on('mouseleave', /** @this {Element} */ function () {
            const $this = $(this);
            setTimeout(function () {
                if (!$('.popover:hover').length) {
                    $this.popover('hide');
                }
            }, 600);
        });
    };

	Ajax({
		'scope': $main,
		'url': '/helen/get',
		'data': {
			'HelenCheckoutID': HelenCheckoutID,
			'Step': $main.attr('data-helen-checkout-step'),
            'QuoteID': $_GET['id'],
            'OrderID': $_GET['OrderID'],
            'CartID': $_GET['cart'],
		},
		'success': function (/** Object<string,*> */ data) {
			$(document).on(':helen.checkout.loaded', function () {
                cartControlsInit(/** @type {!jQuery} */($main.html(/** @type {string} */ (data['content']))));

                gtm(':helen.checkout.load');

				let /** !Big|string */ CartTotal = data['carttotal'];
				let /** !Big|string */ Discount = '0';
				let /** !Big|string */ Tax = '0';
                let /** !Big|string */ TaxAmount = '0';
				let /** !Big|string */ CartShipping = data['cartshipping'];
				let /** !Big|string */ Shipping = '0';
				let /** !Big|string */ Total = '0';

				const $start = $main.find('.helen-checkout-start');
				const $classic = $main.find('.helen-checkout-classic');
				const $quotes = $main.find('.helen-checkout-quotes');
				const $cart = $main.find('.helen-checkout-cart');
				const $checkout = $main.find('.helen-checkout-checkout');
				const $end = $main.find('.helen-checkout-end');

				const $parent = $main.find('.helen-checkout-form-parent');

				const START = 0;
				const QUOTES = 1;
				const CLASSIC = 2;
				const CART = 3;
				const CHECKOUT = 4;
				const END = 5;

				const $doc = $(document);

				/**
				 * @param {number} s
				 */
				const Step = function (s) {
					$parent.removeClass('helen-checkout-form-parent-start helen-checkout-form-parent-quotes helen-checkout-form-parent-classic helen-checkout-form-parent-cart helen-checkout-form-parent-checkout helen-checkout-form-parent-end');
					switch (s) {
					case START:
						$parent.addClass('helen-checkout-form-parent-start');
						$doc.trigger(':helen.checkout.start');
						window.location.hash = "#start";
						break;
					case QUOTES:
						$parent.addClass('helen-checkout-form-parent-quotes');
						$doc.trigger(':helen.checkout.quotes');
						window.location.hash = "#quotes";
						break;
					case CLASSIC:
						$parent.addClass('helen-checkout-form-parent-classic');
						$doc.trigger(':helen.checkout.classic');
						window.location.hash = "#classic";
						break;
					case CART:
						$parent.addClass('helen-checkout-form-parent-cart');
						$doc.trigger(':helen.checkout.cart');
						window.location.hash = "#cart";
						break;
					case CHECKOUT:
						$parent.addClass('helen-checkout-form-parent-checkout');
						$doc.trigger(':helen.checkout.checkout');
						window.location.hash = "#checkout";
						break;
					case END:
						$parent.addClass('helen-checkout-form-parent-end');
						$doc.trigger(':helen.checkout.end');
						window.location.hash = "#end";
						break;
					}

					setTimeout(function () {
						$("html, body").animate({'scrollTop': 0}, 150);
					});
				}

				if ($parent.hasClass('helen-checkout-form-parent-start')) {
					Step(START);
				} else if ($parent.hasClass('helen-checkout-form-parent-quotes')) {
					Step(QUOTES);
				} else if ($parent.hasClass('helen-checkout-form-parent-classic')) {
					Step(CLASSIC);
				} else if ($parent.hasClass('helen-checkout-form-parent-cart')) {
					Step(CART);
				} else if ($parent.hasClass('helen-checkout-form-parent-checkout')) {
					Step(CHECKOUT);
				} else if ($parent.hasClass('helen-checkout-form-parent-end')) {
					Step(END);
				}

				let /** string */ hash = window.location.hash;
				// let /** string */ lastHash = hash;
				const CheckHash = setInterval(function () {
					if (window.location.hash !== hash) {
						// lastHash = hash;
						hash = window.location.hash;
						if (hash === '#end') {
							clearInterval(CheckHash);
							return;
						}
						// alert("User went back or forward to application state represented by " + hash);
						switch (hash) {
						case '#start':
							Step(START);
							break;
						case '#quotes':
							Step(QUOTES);
							break;
						case '#classic':
							Step(CLASSIC);
							break;
						case '#cart':
							Step(CART);
							break;
						case '#checkout':
							Step(CHECKOUT);
							break;
						}
					}
				}, 100);

				/**
				 * @param {!jQuery} $parent
				 */
				const Back = function ($parent) {
					if ($parent.hasClass('helen-checkout-form-parent-quotes')) {
						setTimeout(function () {
							$parent.find('.helen-checkout-email-input').trigger('focus').trigger('select');
						});
					} else if ($parent.hasClass('helen-checkout-form-parent-classic')) {
						if (ClassicForm) {
							setTimeout(function () {
								$parent.find('.helen-checkout-email-input').trigger('focus').trigger('select');
							});
						}
					}

					window.history.back();
				}

				const UpdateTotals = function () {
                    let storeCredit = $checkout.find('.helen-checkout-store-credit-input').val();
                    if (typeof storeCredit === 'string' && !strempty(storeCredit)) {
                        try {
                            storeCredit = Big('0').sub(storeCredit);
                        } catch (_) {
                            storeCredit = '0';
                        }
                    } else {
                        storeCredit = '0';
                    }
					const tax = strempty(/** @type {string} */ ($checkout.find('.helen-checkout-tax-exemption-reason').val())) ? TaxAmount : '0';
                    const shipping = Big(CartShipping).add(Shipping);
                    Total = Big(CartTotal).sub(Discount).add(storeCredit).add(tax).add(shipping);

					if (Tax > 0) {
						$checkout.find('.helen-checkout-tax-percent-parent').removeClass('d-none');
						$checkout.find('.helen-checkout-tax-percent').text(String(Big(Tax).times('100')));
					} else {
						$checkout.find('.helen-checkout-tax-percent-parent').addClass('d-none');
					}

					$cart.find('.helen-checkout-subtotal-discount').text(dollar_format(Big(CartTotal).add(CartShipping).sub(Discount)));
					if ($cart.find('.helen-checkout-cart-item').length === 0) {
						$cart.find('.helen-checkout-checkout-button').attr('disabled', true);
					} else {
						$cart.find('.helen-checkout-checkout-button').removeAttr('disabled');
					}

					$checkout.find('.helen-checkout-subtotal').text(dollar_format(CartTotal));
                    $checkout.find('.helen-checkout-discount').text(dollar_format(Big('0').sub(Discount)));
                    $checkout.find('.helen-checkout-store-credit').text(dollar_format(storeCredit));
					$checkout.find('.helen-checkout-tax').text(dollar_format(tax));
					$checkout.find('.helen-checkout-shipping').text(dollar_format(shipping));
					$checkout.find('.helen-checkout-total').text(dollar_format(Total));
                };

                $checkout.find('.helen-checkout-store-credit-input').on('input', $.debounce(750, /** @this {Element} */ function () {
                    Ajax({
                        url: '/helen/getstorecredit',
                        data: {
                            'StoreCredit': $(this).val()
                        },
                        success: function (/** Object<string,?> */ data) {
                            CartTotal = /** @type {string} */ (data['carttotal']);
                            CartShipping = /** @type {string} */ (data['cartshipping']);
                            UpdateTotals();
                        }
                    });
				}));

				$main.find('.helen-checkout-form').on('submit', /** @this {Element} */ function (/** Event */ e) {
					e.preventDefault();

					const $CheckoutEmailInput = $start.find('.helen-checkout-email-input');
					const $CheckoutGetQuotesButton = $start.find('.helen-checkout-get-quotes-button');

					let Email = /** @type {string} */ ($CheckoutEmailInput.val());

					const l = Ladda.create($CheckoutGetQuotesButton[0]);
					l.start();

					const $e = $CheckoutEmailInput.add($CheckoutGetQuotesButton).attr({'disabled': true});
					const EnableControls = function () {
						$e.attr({'disabled': false});
						l.stop();
                    };

					Ajax({
						'url': '/helen/getquotes',
						'data': {
							'Email': Email,
							'HelenCheckoutID': HelenCheckoutID
						},
						'success': function (/** Object<string,?> */ data) {
							Email = /** @type {string} */ (data['email']);
							const $CheckoutButtonCount = $parent.find('.helen-checkout-quote-checkout-count');
							$quotes.find('.helen-checkout-email').text(Email);
							$classic.find('.helen-checkout-email').text(Email);
							$checkout.find('.helen-checkout-shipping-email-input,.helen-checkout-billing-email-input').val(Email);

							if ('oldform' in data) {
								ClassicForm = true;
								$classic.find('.helen-checkout-back-link-parent').removeClass('d-none');
								Step(CLASSIC);
							} else {
								ClassicForm = false;
								$quotes.find('.helen-checkout-quotes-parent').html(/** @type {string} */ (data['content']));

								$quotes.find('.helen-checkout-quote-main').on('height:check', /** @this {Element} */ function () {
									if (this.scrollHeight > this.clientHeight) {
										$(this).addClass('helen-checkout-quote-main-long');
									} else {
										$(this).removeClass('helen-checkout-quote-main-long');
									}
								}).trigger('height:check');

								$quotes.find('.helen-checkout-quote-see-more-parent>a').on('click', /** @this {Element} */ function (/** Event */ e) {
									e.preventDefault();
									e.stopPropagation();

									$(this).closest('.helen-checkout-quote').find('.helen-checkout-quote-main').addClass('helen-checkout-quote-main-long-visible');
								});

								$quotes.find('.helen-checkout-quote-share-link').on('click', /** @this {Element} */ function (/** Event */ e) {
									e.preventDefault();
									e.stopPropagation();
									const $this = $(this);
									const $q = $this.closest('.helen-checkout-quote');

									Dialog({
										title: 'Share a link to your quote',
										input: 'text',
										inputValue: window.location.protocol + '//' + window.location.host + '/myquote?id=' + encodeURIComponent(/** @type {string} */ ($q.attr('data-quote-hash'))),
										continue: 'Close'
									});
									const $i = $(swal.getInput()).attr({'readonly': true}).on('focus', /** @this {Element} */ function () {
										$(this).trigger('select');
									});
									setTimeout(function () {
										$i.trigger('focus');
									});
								});

								$quotes.find('.helen-checkout-quote-see-less-parent>a').on('click', /** @this {Element} */ function (/** Event */ e) {
									e.preventDefault();
									e.stopPropagation();

									$(this).closest('.helen-checkout-quote').find('.helen-checkout-quote-main').removeClass('helen-checkout-quote-main-long-visible');
								});

								$quotes.find('.helen-checkout-quote-proofs-parent-two,.helen-checkout-quote-proofs-parent-many').each(/** @this {Element} */ function () {
									const $this = $(this);
									const $m = $this.masonry({
										'gutter': .5 * rem(),
										'horizontalOrder': true,
									});
									$m.imagesLoaded().progress(function () {
										$m.masonry('layout');
										$this.closest('.helen-checkout-quote-main').trigger('height:check');
									});
								});

								Step(QUOTES);

								$quotes.find('.helen-checkout-quote-show-breakdown-link,.helen-checkout-quote-hide-breakdown-link').on('click', /** @this {Element} */ function (/** Event */ e) {
									e.preventDefault();
									e.stopPropagation();

									const $this = $(this);

									$this.closest('.helen-checkout-quote').toggleClass('helen-checkout-quote-breakdown-visible');
									setTimeout(function () {
										$this.closest('.helen-checkout-quote').find('.helen-checkout-quote-main').trigger('height:check')
									}, 200);
								});

								$quotes.find('.helen-checkout-quote').on('click', /** @this {Element} */ function (/** Element */ e) {
									if (get_selected_text() === '' && !$(e['target']).is('a,button,img')) {
										$(this).find('.helen-checkout-quote-show-breakdown-link').trigger('click');
									}
								});

								const $CheckoutButton = $parent.find('.helen-checkout-quotes-checkout-button').on('click', function () {
									$cart.find('.helen-checkout-back-button').removeClass('d-none');
									Step(CART);
								});
								/**
								 * @param {number} n
								 * @param {string} cart
								 * @param {string} total
								 * @param {string} shipping
                                 * @param {string} promocode
								 */
								const success = function (n, cart, total, shipping, promocode) {
									if (n !== 0) {
										$CheckoutButtonCount.text(n);
										$CheckoutButton.removeClass('d-none');
									} else {
										$CheckoutButton.addClass('d-none');
									}
                                    $main.find('.helen-checkout-cart-items-parent').html(cart);

									// $cart.find('.helen-checkout-cart-total').text(total);
									CartTotal = total;
                                    CartShipping = shipping;

                                    if (!strempty(promocode) && strempty(String($checkout.find('.helen-checkout-promo-input').val()))) {
                                        $checkout.find('.helen-checkout-promo-input').val(promocode).trigger('input');
                                    } else {
                                        UpdateTotals();
                                    }
								};
								$quotes.find('.helen-checkout-quote-select-button').on('click', /** @this {Element} */ function () {
									const $this = $(this);
									const $q = $this.closest('.helen-checkout-quote');
									$q.addClass('active');

									AddQuoteToCart(/** @type {string} */ ($q.attr('data-quote-id')),
										/**
										 * @param {number} n
										 * @param {string} cart
										 * @param {string} total
										 * @param {string} shipping
                                         * @param {string} promocode
										 */
										function (n, cart, total, shipping, promocode) {
										if (!FirstCartItemAdded) {
											FirstCartItemAdded = true;
											Dialog({
												title: "Quote added to your cart!",
												text: "Want to add anything else to your cart? You can checkout anytime by clicking the button in the top right.",
												type: 'success',
												confirm: 'Go to cart',
												cancel: 'Keep shopping',
												success: function () {
													$CheckoutButton.trigger('click');
												}
											});
										}

										success(n, cart, total, shipping, promocode);
									});
								});
								$quotes.find('.helen-checkout-quote-deselect-button').on('click', /** @this {Element} */ function () {
									const $this = $(this);
									const $q = $this.closest('.helen-checkout-quote');
									$q.removeClass('active');

									DeleteQuoteFromCart(/** @type {string} */ ($q.attr('data-quote-id')), success);
								});

								setTimeout(function () {
									EnableControls();
								}, 150);
							}

							setTimeout(function () {
								EnableControls();
                            }, 300);
                            gtm(':helen.checkout.getquotes.success');
						},
						'error': function () {
                            EnableControls();
                            gtm(':helen.checkout.getquotes.error');
						}
					});
				});

				$main.find('.helen-checkout-back-link,.helen-checkout-back-button').on('click', function (/** Event */ e) {
					e.preventDefault();

					Back($parent);
				});

				const $CartButton = $quotes.find('.helen-checkout-quotes-checkout-button');
				const CartButtonOffset = $CartButton.offset();
				let /** boolean */ CartButtonSticky = false;
				$(window).on('scroll', function () {
					if (CartButtonOffset.top < $(window).scrollTop() && !CartButtonSticky) {
						$CartButton.addClass('helen-checkout-quotes-checkout-button-sticky');
						CartButtonSticky = true;
					} else if (CartButtonOffset.top >= $(window).scrollTop() && CartButtonSticky) {
						$CartButton.removeClass('helen-checkout-quotes-checkout-button-sticky');
						CartButtonSticky = false;
					}
				}).trigger('scroll');

				$cart.find('.helen-checkout-checkout-button').on('click', function () {
					Step(CHECKOUT);
					$checkout.find('.helen-checkout-back-button').removeClass('d-none');

                    Ajax({
                        url: '/helen/getstorecredit',
                        success: function (/** Object<string,?> */ data) {
                            CartTotal = /** @type {string} */ (data['carttotal']);
                        }
                    });
				});

				$cart.on('focus', '.helen-checkout-quantity-input', /** @this {Element} */ function () {
					$(this).one('mouseup', function (/** Event */ e) {
						e.preventDefault();
					}).trigger('select');
                });

				$cart.on('input', '.helen-checkout-quantity-input', $.debounce(750, /** @this {Element} */ function () {
					const $this = $(this);
					const $CartItem = $this.closest('.helen-checkout-cart-item');
					Ajax({
						scope: $CartItem,
						url: '/helen/updatequantity',
						data: {
							'CartItemID': $CartItem.attr('data-cart-item-id'),
							'Quantity': $this.val(),
						},
						success: function (/** Object<string,*> */ data) {
							cartControlsInit(/** @type {!jQuery} */($main.find('.helen-checkout-cart-items-parent').html(/** @type {string} */ (data['cart']))));
							$quotes.find('.helen-checkout-quote-checkout-count').text(/** @type {number} */ (data['cartitemscount']));

							CartTotal = /** @type {string} */ (data['carttotal']);
							CartShipping = /** @type {string} */ (data['cartshipping']);
                            UpdateTotals();
                            gtm(':helen.checkout.updatequantity.success');
                        },
                        error: function () {
                            gtm(':helen.checkout.updatequantity.error');
                        },
					});
				}));

				$cart.on('click', '.helen-checkout-remove-link', /** @this {Element} */ function (/** Event */ e) {
					e.preventDefault();

					const $c = $(this).closest('li.helen-checkout-cart-item').removeClass('d-flex').addClass('d-none');
					const first = !$c.hasClass('pt-4');
					if (first) {
						$c.next('li.helen-checkout-cart-item').removeClass('pt-4');
					}

					Ajax({
						url: '/helen/deletecartitem',
						data: {
							'CartItemID': $c.attr('data-cart-item-id'),
						},
						success: function (/** Object<string,?> */ data) {
							if ($c.is('[data-quote-id]')) {
								$quotes.find('.helen-checkout-quote[data-quote-id="' + (/** @type {string} */ ($c.attr('data-quote-id'))) + '"]').removeClass('active');
							}
							cartControlsInit(/** @type {!jQuery} */($main.find('.helen-checkout-cart-items-parent').html(/** @type {string} */ (data['cart']))));
							$quotes.find('.helen-checkout-quote-checkout-count').text(/** @type {number} */ (data['cartitemscount']));

							CartTotal = /** @type {string} */ (data['carttotal']);
							CartShipping = /** @type {string} */ (data['cartshipping']);
                            UpdateTotals();
                            gtm(':helen.checkout.deletecartitem.success');
						},
						error: function () {
							$c.addClass('d-flex').removeClass('d-none');
							if (first) {
								$c.next().addClass('pt-4');
                            }
                            gtm(':helen.checkout.deletecartitem.error');
						},
					});
				});

				$cart.find('.helen-checkout-start-link').on('click', function (/** Event */ e) {
					e.preventDefault();
					Step(START);
				});

				$main.find('input[type="tel"]').each(/** @this {Element} */ function () {
					const $this = $(this);
					$this.data('iti', intlTelInput(this, {
						'dropdownContainer': document.body,
						'separateDialCode': true,
						'autoPlaceholder': 'aggressive',
						'utilsScript': 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.min.js',
						'customPlaceholder': function (/** string */ selectedCountryPlaceholder, _) {
							return "e.g. " + selectedCountryPlaceholder;
						},
					}));
					setTimeout(function () {
						$this.attr('autocomplete', 'tel-national');
					});
				});

				const addresses = ['shipping', 'billing'];
				for (let i = 0; i < addresses.length; i++) {
					const $c = $checkout.find('.helen-checkout-'+addresses[i]+'-country-select');
					const $s = $checkout.find('.helen-checkout-'+addresses[i]+'-state-select');
					$c.on('change', function () {
						$s.resetOptions().find('option[data-country-id]:not([data-country-id="' + (/** @type {string} */ ($c.val())) + '"])').hideOptions();
						if ($s.find('option[data-country-id]').length === 0) {
							$c.parent().removeClass('col-xl-6').addClass('col-xl-9');
							$s.removeAttr('required').removeData('required').parent().addClass('d-none');
						} else {
							$c.parent().addClass('col-xl-6').removeClass('col-xl-9');
							$s.parent().removeClass('d-none');
							if ($c.is('[required]')) {
								$s.attr('required', true).data('required', true);
							}
						}
						$s.trigger('change');
					}).trigger('change');
				}

				const inputs = ['full-name', 'company', 'address-line-1', 'address-line-2', 'city', 'zip', 'phone', 'email'];
				const selects = ['country', 'state'];

				const $BillingPhone = $checkout.find('.helen-checkout-billing-phone-input');
				const $ShippingPhone = $checkout.find('.helen-checkout-shipping-phone-input');

				let BillingPhoneIti = /** @type {!iti} */ ($BillingPhone.data('iti'));
				let ShippingPhoneIti = /** @type {!iti} */ ($ShippingPhone.data('iti'));

				const $SameAsShipping = $checkout.find('.helen-checkout-same-as-shipping-checkbox');

				for (let i = 0; i < inputs.length; i++) {
					const $e = $checkout.find('.helen-checkout-shipping-'+inputs[i]+'-input');
					$e.on('input', function () {
						if ($SameAsShipping.is(':checked')) {
							$checkout.find('.helen-checkout-billing-'+inputs[i]+'-input').val(/** @type {string} */($e.val()));
						}
					});
				}

				for (let i = 0; i < selects.length; i++) {
					const $e = $checkout.find('.helen-checkout-shipping-'+selects[i]+'-select');
					$e.on('change', function () {
						if ($SameAsShipping.is(':checked')) {
							$checkout.find('.helen-checkout-billing-'+selects[i]+'-select').val(/** @type {string} */($e.val())).trigger('change');
						}
					});
				}

				$ShippingPhone.on('countrychange', function () {
					if (/** @type {boolean} */ ($SameAsShipping.prop('checked'))) {
						try {
							BillingPhoneIti.setCountry(ShippingPhoneIti.getSelectedCountryData()['iso2']);
						} catch(_) {}
					}
				});

				$SameAsShipping.on('click :helen-click', /** @this {Element} */ function () {
					if (/** @type {boolean} */ (this['checked'])) {
						$checkout.find('.helen-checkout-billing-address-parent').addClass('d-none').find('input:not([type="file"]),select').each(/** @this {Element} */ function () {
							const $this = $(this);
							$this.data('required', $this.attr('required'));
							$this.removeAttr('required');
						});
						for (let i = 0; i < inputs.length; i++) {
							const $e = $checkout.find('.helen-checkout-billing-'+inputs[i]+'-input');
							$e.data('val', /** @type {string} */ ($e.val()));
							$e.val(/** @type {string} */ ($checkout.find('.helen-checkout-shipping-'+inputs[i]+'-input').val()));
						}
						for (let i = 0; i < selects.length; i++) {
							const $e = $checkout.find('.helen-checkout-billing-'+selects[i]+'-select');
							$e.data('val', /** @type {string} */ ($e.val()));
							$e.val(/** @type {string} */ ($checkout.find('.helen-checkout-shipping-'+selects[i]+'-select').val())).trigger('change');
						}
						BillingPhoneIti.setCountry(ShippingPhoneIti.getSelectedCountryData()['iso2']);
					} else {
						$checkout.find('.helen-checkout-billing-address-parent').removeClass('d-none').find('input:not([type="file"]),select').each(/** @this {Element} */ function () {
							const $this = $(this);
							if (typeof $this.data('required') !== 'undefined') {
								$this.attr('required', true);
							}
						});
					}
				}).trigger('click');

                const $country = $('.helen-checkout-shipping-country-select');
                const $zip = $('.helen-checkout-shipping-zip-input');
                const $state = $('.helen-checkout-shipping-state-select');
                const $city = $('.helen-checkout-shipping-city-input');
                const $addressLine1 = $('.helen-checkout-shipping-address-line-1-input');

                const updateSalesTax = $.debounce(750, () => {
                    const countryCode2 = String($country.find(':checked').attr('data-country-code-2') || '').trim();
                    const zip = String($zip.val() || '').trim();
                    const stateCode = String($state.find(':checked').attr('data-state-code') || '').trim();
                    const city = String($city.val() || '').trim();
                    const addressLine1 = String($addressLine1.val() || '').trim();

                    if (countryCode2 === 'US' && zip && stateCode && city && addressLine1 && !Big(CartTotal).eq('0')) {
						Ajax({
							url: '/helen/getsalestax',
							data: {
                                'CountryCode2': countryCode2,
								'Zip': zip,
                                'StateCode': stateCode,
                                'City': city,
                                'AddressLine1': addressLine1,
                                'TotalSansTaxAndShipping': CartTotal,
                                'Shipping': CartShipping,
							},
							success: function (/** Object<string,?> */ data) {
								Tax = /** @type {string} */ (data['salestax']);
                                TaxAmount = /** @type {string} */ (data['salestaxamount']);
								CartTotal = /** @type {string} */ (data['carttotal']);
								CartShipping = /** @type {string} */ (data['cartshipping']);
								UpdateTotals();
							},
						});
					} else {
						Tax = '0';
						UpdateTotals();
					}
				});

				$country.add($state).on('change', () => updateSalesTax());
                $zip.add($city).add($addressLine1).on('input', () => updateSalesTax());

				if (!Mobile()) {
					try {
						datepicker($checkout.find('.helen-checkout-date-needed-input').attr('type', 'text')[0], {
							'minDate': new Date(),
							'startDate': new Date(),
							'onSelect': function () {
								$checkout.find('.helen-checkout-date-needed-input').trigger('input');
							}
						});
					} catch (_) {}
				}

				$checkout.find('.helen-checkout-date-needed-input').on('input change', /** @this {Element} */ function () {
					const $this = $(this);
					const Days = Number($this.attr('data-days'));
					if (Days > 0 && moment(/** @type {string} */($this.val())).diff(moment(), 'days') < Days + 1) {
						$checkout.find('.helen-checkout-date-needed-warning').removeClass('d-none');
					} else {
						$checkout.find('.helen-checkout-date-needed-warning').addClass('d-none');
					}
				});

				$checkout.find('.helen-checkout-promo-input').on('input', /** @this {Element} */ function () {
					Ajax({
						url: '/helen/getpromocode',
						data: {
							'Code': $(this).val()
						},
						success: function (/** Object<string,?> */ data) {
							Discount = /** @type {string} */ (data['discount']);
							CartTotal = /** @type {string} */ (data['carttotal']);
							CartShipping = /** @type {string} */ (data['cartshipping']);
							UpdateTotals();

							const desc = /** @type {string} */ (data['description']);
							const name = /** @type {string} */ (data['name']);
							if (!strempty(name)) {
								$checkout.find('.helen-checkout-promo-details').removeClass('d-none');
								$checkout.find('.helen-checkout-promo-name').text(name);
								if (!strempty(desc)) {
									$checkout.find('.helen-checkout-promo-description-parent').removeClass('d-none');
									$checkout.find('.helen-checkout-promo-description').text(desc);
								} else {
									$checkout.find('.helen-checkout-promo-description-parent').addClass('d-none');
								}
							} else {
								$checkout.find('.helen-checkout-promo-details').addClass('d-none');
							}
						}
					});
				}).trigger('input');

				$checkout.find('.helen-checkout-shipping-country-select').on('change', /** @this {Element} */ function () {
					const $this = $(this);

					$checkout.find('.helen-checkout-shipping-zip-input').trigger('input');

					if (Number($this.val()) === COUNTRIES_UNITED_STATES) {
						Shipping = '0';
						UpdateTotals();
						$checkout.find('.helen-checkout-shipping-state-input').trigger('change');
						$checkout.find('.helen-checkout-intl-warning').parent().addClass('d-none');
					} else {
						Ajax({
                            url: '/helen/getintlshipping',
                            data : {
                                'CountryCode': $checkout.find('.helen-checkout-shipping-country-select>option:selected').attr('data-country-code-2'),
                                'Zip': $checkout.find('.helen-checkout-shipping-zip-input').val(),
                            },
							success: function (/** Object<string,?> */ data) {
								Shipping = /** @type {string} */ (data['shipping']);
								CartTotal = /** @type {string} */ (data['carttotal']);
								CartShipping = /** @type {string} */ (data['cartshipping']);

								if (!Big(Shipping).eq('0')) {
									$checkout.find('.helen-checkout-intl-warning').parent().removeClass('d-none');
								}

								UpdateTotals();
							}
						});
					}

					if (strempty(/** @type {string} */ ($ShippingPhone.val()))) {
						try {
							ShippingPhoneIti.setCountry(/** @type {string} */ ($this.find(':selected').attr('data-country-code-2')));
						} catch(_) {}
					}

				});

				$checkout.find('.helen-checkout-billing-country-select').on('change', /** @this {Element} */ function () {
					const $this = $(this);

					if (strempty(/** @type {string} */ ($BillingPhone.val()))) {
						try {
							BillingPhoneIti.setCountry(/** @type {string} */ ($this.find(':selected').attr('data-country-code-2')));
						} catch(_) {}
					}
				});

				let /** boolean */ IntlStateShippingSet;
				$checkout.find('.helen-checkout-shipping-state-select').on('change', /** @this {Element} */ function () {
					IntlStateShippingSet = false;

					if (Number($checkout.find('.helen-checkout-shipping-country-select').val()) === COUNTRIES_UNITED_STATES) {
						if ($(this).find(':selected').is('[data-apo]')) {
							Ajax({
								url: '/helen/getaposhipping',
								success: function (/** Object<string,?> */ data) {
									Shipping = /** @type {string} */ (data['shipping']);
									CartTotal = /** @type {string} */ (data['carttotal']);
									CartShipping = /** @type {string} */ (data['cartshipping']);

									if (!Big(Shipping).eq('0')) {
										$checkout.find('.helen-checkout-apo-warning').parent().removeClass('d-none');
									}

									UpdateTotals();
								}
							});
						} else if ($(this).find(':selected').is('[data-international]')) {
							Ajax({
								url: '/helen/getintlshipping',
								success: function (/** Object<string,?> */ data) {
									if (IntlStateShippingSet) {
										return;
									}

									Shipping = /** @type {string} */ (data['shipping']);
									CartTotal = /** @type {string} */ (data['carttotal']);
									CartShipping = /** @type {string} */ (data['cartshipping']);

									if (!Big(Shipping).eq('0')) {
										$checkout.find('.helen-checkout-intl-warning').parent().removeClass('d-none');
									}

									UpdateTotals();
								}
							});
						} else {
							IntlStateShippingSet = true;
							Shipping = '0';
							UpdateTotals();
							$checkout.find('.helen-checkout-apo-warning').parent().addClass('d-none');
							$checkout.find('.helen-checkout-intl-warning').parent().addClass('d-none');
						}
					}
				});

				ImageUpload({
					dropZone: $checkout.find('.helen-checkout-shipping-parent'),
					button: $checkout.find('.helen-checkout-exempt-image-upload-button'),
					input: '.helen-checkout-exempt-image-upload-input',
					template: '.helen-checkout-exempt-image-template',
					deleteLink: '.helen-checkout-exempt-image-delete-link',
					image: '.helen-checkout-exempt-image',
                    parent: '.helen-checkout-exempt-images',
                    link: '.helen-checkout-exempt-image-link',
				});

				$checkout.find('.helen-checkout-shipping-state-select,.helen-checkout-shipping-country-select').on('change', /** @this {Element} */ function () {
					if ($checkout.find('.helen-checkout-shipping-country-select :selected').attr('data-country-code-2') === 'US') {
						$checkout.find('.helen-checkout-tax-warning').removeClass('d-none').add($checkout.find('.helen-checkout-exempt-id-input,.helen-checkout-exempt-image-upload-input')).parent().removeClass('d-none');
                        $checkout.find('.helen-checkout-tax-international-warning').addClass('d-none');
					} else {
                        $checkout.find('.helen-checkout-tax-international-warning').removeClass('d-none').parent().removeClass('d-none');
                        $checkout.find('.helen-checkout-tax-warning').addClass('d-none').add($checkout.find('.helen-checkout-exempt-id-input,.helen-checkout-exempt-image-upload-input')).parent().addClass('d-none');
                        $checkout.find('.helen-checkout-exempt-images').addClass('d-none');
					}
				});

                const $taxExemptionParent = $checkout.find('.helen-checkout-tax-exemption-parent');
                const $shippingCountry = $checkout.find('.helen-checkout-shipping-country-select');
                const $taxExemptReason = $checkout.find('.helen-checkout-tax-exemption-reason');
                const $taxExemptFields = $checkout.find('.helen-checkout-tax-exempt-field');
                // const $taxExemptNumber = $checkout.find('.helen-checkout-exempt-id-input');

                $shippingCountry.on('change', () => {
                    if ($shippingCountry.find(':selected').attr('data-country-code-2') === 'US') {
                        $taxExemptionParent.removeClass('d-none');
                    } else {
                        $taxExemptionParent.addClass('d-none');
                    }
                }).trigger('change');

                $taxExemptReason.on('change', () => {
                    if ($taxExemptReason.val()) {
                        $taxExemptFields.removeClass('d-none');
                    } else {
                        $taxExemptFields.addClass('d-none');
                    }
                    UpdateTotals();
                }).trigger('change');

				ImageUpload({
					dropZone: $checkout.find('.helen-checkout-billing-parent'),
					button: $checkout.find('.helen-checkout-po-image-upload-button'),
					input: '.helen-checkout-po-image-upload-input',
					template: '.helen-checkout-po-image-template',
					deleteLink: '.helen-checkout-po-image-delete-link',
					image: '.helen-checkout-po-image',
                    parent: '.helen-checkout-po-images',
                    link: '.helen-checkout-po-image-link',
				});

				if (typeof $_GET['promo'] === 'string') {
					$checkout.find('.helen-checkout-promo-input').val($_GET['promo']).trigger('input');
				}

				for (let i = 0; i < addresses.length; i++) {
					/** @suppress {reportUnknownTypes} */
					const autocomplete = new google.maps.places.Autocomplete(/** @type {!HTMLInputElement} */ ($checkout.find('.helen-checkout-'+addresses[i]+'-address-line-1-input')[0]), {types: ['geocode']});
					autocomplete.addListener('place_changed', function () {
						const place = autocomplete.getPlace();
						let country, state, zip = '', city = '';
						for (let j = 0; j < place.address_components.length; j++) {
							switch (place.address_components[j].types[0]) {
							case 'postal_town':
							case 'locality':
								city = place.address_components[j].long_name;
								break;
							case 'administrative_area_level_1':
								state = place.address_components[j].short_name;
								break;
							case 'country':
								country = place.address_components[j].short_name;
								break;
							case 'postal_code':
								zip = place.address_components[j].short_name;
								break;
							}
						}
						$checkout.find('.helen-checkout-'+addresses[i]+'-address-line-1-input').val(place.name).trigger('input');
						$checkout.find('.helen-checkout-'+addresses[i]+'-address-line-2-input').val('').trigger('input');
						$checkout.find('.helen-checkout-'+addresses[i]+'-state-select').val(/** @type {string} */
							($checkout.find('.helen-checkout-'+addresses[i]+'-state-select [data-state-code="'+String(state)+'"]').val()));
						$checkout.find('.helen-checkout-'+addresses[i]+'-country-select').val(/** @type {string} */
							($checkout.find('.helen-checkout-'+addresses[i]+'-country-select [data-country-code-2="'+country+'"]').val())).trigger('change');
						$checkout.find('.helen-checkout-'+addresses[i]+'-city-input').val(city).trigger('input');
						$checkout.find('.helen-checkout-'+addresses[i]+'-zip-input').val(zip).trigger('input');
						setTimeout(function () {
							$checkout.find('.helen-checkout-shipping-phone-input').trigger('focus');
						});
					});

					$checkout.find('.helen-checkout-'+addresses[i]+'-address-line-1-input').on('keydown', function (/** Event */ e) {
						if (e.which === 13 && $('.pac-container:visible').length) return false;
					});
				}

				const $inputs = $checkout.find('input');
				$inputs.filter('[maxlength]').on('input', /** @this {Element} */ function () {
					const $this = $(this);
					const m = Number($this.attr('maxlength'));
					const v = /** @type {string} */ ($this.val());

					if (v.length >= m) {
						const $next = $inputs.eq($inputs.index($this) + 1);
						if ($next.length !== 0) {
							$next.trigger('focus');
						} else {
							$this.trigger('blur');
						}
					}
                });

                const $CreditCardNumberInput = $checkout.find('.helen-checkout-card-input');
                const $CreditCardSecurityInput = $checkout.find('.helen-checkout-security-input');

                let paypalAuthID = '';

				$checkout.find('.helen-checkout-checkout-form').on('submit', async function (/** Event */ e) {
					e.preventDefault();

					const $Controls = $checkout.find('input,select,button,a,textarea');
					const l = Ladda.create($checkout.find('.helen-checkout-confirm-purchase-button')[0]);
					l.start();
                    $Controls.attr('disabled', true);

                    const BillingFullName = $checkout.find('.helen-checkout-billing-full-name-input').val();

                    const CreditCardMonth = $checkout.find('.helen-checkout-month-input').val();
                    const CreditCardYear = $checkout.find('.helen-checkout-year-input').val();

                    const $BillingCountrySelect = $checkout.find('.helen-checkout-billing-country-select');
                    const $BillingStateSelect = $checkout.find('.helen-checkout-billing-state-select');

                    const data = {
                        'HelenCheckoutID': HelenCheckoutID,
                        'FormSubmissionID': $checkout.find('.helen-checkout-form-input').val(),
                        'ShippingFullName': $checkout.find('.helen-checkout-shipping-full-name-input').val(),
                        'ShippingCompany': $checkout.find('.helen-checkout-shipping-company-input').val(),
                        'ShippingAddressLine1': $checkout.find('.helen-checkout-shipping-address-line-1-input').val(),
                        'ShippingAddressLine2': $checkout.find('.helen-checkout-shipping-address-line-2-input').val(),
                        'ShippingCity': $checkout.find('.helen-checkout-shipping-city-input').val(),
                        'ShippingCountryID': $checkout.find('.helen-checkout-shipping-country-select').val(),
                        'ShippingStateID': $checkout.find('.helen-checkout-shipping-state-select').val(),
                        'ShippingZip': $checkout.find('.helen-checkout-shipping-zip-input').val(),
                        'ShippingPhone': ShippingPhoneIti.getNumber(),
                        '_ShippingPhone': $checkout.find('.helen-checkout-shipping-phone-input').val(),
                        'ShippingEmail': $checkout.find('.helen-checkout-shipping-email-input').val(),
                        'BillingFullName': BillingFullName,
                        'BillingCompany': $checkout.find('.helen-checkout-billing-company-input').val(),
                        'BillingAddressLine1': $checkout.find('.helen-checkout-billing-address-line-1-input').val(),
                        'BillingAddressLine2': $checkout.find('.helen-checkout-billing-address-line-2-input').val(),
                        'BillingCity': $checkout.find('.helen-checkout-billing-city-input').val(),
                        'BillingCountryID': $BillingCountrySelect.val(),
                        'BillingStateID': $BillingStateSelect.val(),
                        'BillingZip': $checkout.find('.helen-checkout-billing-zip-input').val(),
                        'BillingPhone': BillingPhoneIti.getNumber(),
                        '_BillingPhone': $checkout.find('.helen-checkout-billing-phone-input').val(),
                        'BillingEmail': $checkout.find('.helen-checkout-billing-email-input').val(),
                        'PaymentOptionTypeID': $checkout.find('input[name="helen-checkout-payment-option"]:checked').val(),
                        'PromotionalApproval': $checkout.find('.helen-checkout-promotional-approval-checkbox').is(':checked'),
                        'Accuracy': $checkout.find('.helen-checkout-accuracy-checkbox').is(':checked'),
                        'PromotionalCode': $checkout.find('.helen-checkout-promo-input').val(),
                        'PurchaseOrderNumber': $checkout.find('.helen-checkout-po-input').val(),
                        'PurchaseOrderImageIDs': $checkout.find('.helen-checkout-po-image').map(/** @this {Element} */function () { return $(this).attr('data-image-id') }).get(),
                        'DateNeeded': $checkout.find('.helen-checkout-date-needed-input').val(),
                        'Notes': $checkout.find('.helen-checkout-notes').val(),
                        'CreditCardMonth': CreditCardMonth,
                        'CreditCardYear': CreditCardYear,
                        'Check': $checkout.find('.helen-checkout-check-checkbox').is(':checked'),
                        'Wire': $checkout.find('.helen-checkout-wire-checkbox').is(':checked'),
                        'Balance': $checkout.find('.helen-checkout-store-credit-input').val(),
                        'PageRequestID': await window['GetPageRequestID']?.(),
                        'SMS': $checkout.find('.helen-checkout-sms-checkbox').is(':checked'),
                        'PayPalAuthID': paypalAuthID,
                        'tz': new Intl.DateTimeFormat().resolvedOptions().timeZone,

                        'taxExemption': {
                            'reason': $checkout.find('.helen-checkout-tax-exemption-reason').val(),
                            'number': $checkout.find('.helen-checkout-exempt-id-input').val(),
                            'imageIDs': $checkout.find('.helen-checkout-exempt-image').map(/** @this {Element} */function () { return $(this).attr('data-image-id') }).get(),
                        },
                    };

                    const stop = function () {
                        $Controls.removeAttr('disabled');
                        l.stop();
                    }

                    const fn = function () {
                        Ajax({
                            scope: $checkout,
                            url: '/helen/neworder',
                            data: data,
                            success: function (/** Object<string,*> */ data) {
                                $end.find('.helen-checkout-details-parent').html(/** @type {string} */ (data['details']));
                                $end.find('.helen-checkout-first-name').text(/** @type {string} */ (data['firstname']));
                                $end.find('.helen-checkout-email').text(/** @type {string} */ (data['email']));
                                $parent.removeClass('helen-checkout-form-parent-checkout').addClass('helen-checkout-form-parent-end');
                                Step(END);
                                gtm(':helen.checkout.neworder.success');
                            },
                            error: function (_, /** Object<string,*> */ resp) {
                                stop();
                                const FormID = /** @type {string} */ (resp['formsubmissionid']);
                                if (!strempty(FormID)) {
                                    $checkout.find('.helen-checkout-form-input').val(FormID);
                                }
                                gtm(':helen.checkout.neworder.error');
                            }
                        });
                    };

                    data['CreditCardNumber'] = $CreditCardNumberInput.val();
                    data['CreditCardSecurity'] = $CreditCardSecurityInput.val();

                    fn();
				});

				$quotes.find('.helen-checkout-show-classic-link').on('click', function (/** Event */ e) {
					$classic.find('.helen-checkout-back-link-parent').addClass('d-none');
					Step(CLASSIC);
				});

				$parent.on('click', '.helen-checkout-search-link', function (/** Event */ e) {
					e.preventDefault();

					Step(START);
					setTimeout(function () {
						$start.find('.helen-checkout-email-input').trigger('focus').trigger('select');
					});
				});

				const $Products = $classic.find('.helen-checkout-product-select');
				const $Types = $classic.find('.helen-checkout-type-select');
				const $Sizes = $classic.find('.helen-checkout-size-select');
				const $Children = $classic.find('.helen-checkout-child-select');

				$Types.on('change', /** @this {Element} */ function () {
					const $this = $(this);
					$Sizes.resetOptions().find('[data-line-item-type-id]:not([data-line-item-type-id="' + /** @type {string} */($this.val()) + '"])').hideOptions();
					if ($Sizes.find('[data-line-item-type-id]').length === 0) {
						$Sizes.removeAttr('required').parent().addClass('d-none');
					} else {
						$Sizes.attr('required', true).parent().removeClass('d-none');
					}
				}).trigger('change');

				$Products.on('change', /** @this {Element} */ function () {
					const $this = $(this);
					$Types.resetOptions().find('[data-line-item-id]:not([data-line-item-id="' + /** @type {string} */($this.val()) + '"])').hideOptions();
					if ($Types.find('[data-line-item-id]').length === 0) {
						$Types.removeAttr('required').parent().addClass('d-none');
					} else {
						$Types.attr('required', true).parent().removeClass('d-none');
					}

					$Children.removeAttr('required').parent().addClass('d-none');
					$Children.filter('[data-line-item-id="' + /** @type {string} */($this.val()) + '"]').attr('required', true).parent().removeClass('d-none');
				}).trigger('change');

				$classic.find('select').on('change', /** @this {Element} */ function () {
					const $this = $(this);

					if ($this.val() === 'other') {
						const $i = $this.nextAll('input').eq(0);
						$i.removeClass('d-none').attr('required', true);
						setTimeout(function () {
							$i.trigger('focus');
						});
					} else {
						$this.nextAll('input').eq(0).addClass('d-none').removeAttr('required');
					}
				});

				$classic.find('.helen-checkout-classic-form').on('submit', async function (/** Event */ e) {
					e.preventDefault();

					const $Controls = $classic.find('input,select,button,a,textarea');
					const l = Ladda.create($classic.find('.helen-checkout-continue-button')[0]);
					l.start();
					$Controls.attr('disabled', true);

					Ajax({
						scope: $classic,
						url: '/helen/classicquote',
						data: {
							'FormSubmissionID': $classic.find('.helen-checkout-form-input').val(),
							'Proofs': $classic.find('.helen-checkout-proofs-input').val(),
							'LineItemID': $classic.find('.helen-checkout-product-select').val(),
							'LineItem': $classic.find('.helen-checkout-product-select').nextAll('input').eq(0).val(),
							'LineItemTypeID': $classic.find('.helen-checkout-type-select').val(),
							'Type': $classic.find('.helen-checkout-type-select').nextAll('input').eq(0).val(),
							'LineItemTypeSizeID': $classic.find('.helen-checkout-size-select').val(),
							'Size': $classic.find('.helen-checkout-size-select').nextAll('input').eq(0).val(),
							'Quantity': $classic.find('.helen-checkout-quantity-input').val(),
							'ChildLineItems': $classic.find('.form-group:not(.d-none)>.helen-checkout-child-select').map(/** @this {Element} **/ function () {
								const $this = $(this);
								return {
									'ChildLineItemID': $this.attr('name'),
									'ChildLineItemOptionID': $this.val(),
									'Option': $this.nextAll('input').eq(0).val(),
								};
							}).get(),
							'Total': $classic.find('.helen-checkout-total-input').val(),
							'Email': $classic.find('.helen-checkout-email').text(),
							'PageRequestID': (await window['GetPageRequestID']?.()) || (typeof window['PageRequestXHR'] === 'object' && window['PageRequestXHR'] !== null &&
								'responseText' in window['PageRequestXHR'] ? String(window['PageRequestXHR']['responseText']) : null)
						},
						success: function (/** Object<string,*> */ data) {
							cartControlsInit(/** @type {!jQuery} */($main.find('.helen-checkout-cart-items-parent').html(/** @type {string} */ (data['cart']))));
							$quotes.find('.helen-checkout-quote-checkout-count').text(/** @type {number} */ (data['cartitemscount']));

							CartTotal = /** @type {string} */ (data['carttotal']);
							CartShipping = /** @type {string} */ (data['cartshipping']);
							UpdateTotals();

							$cart.find('.helen-checkout-back-button').removeClass('d-none');

							$parent.removeClass('helen-checkout-form-parent-classic').addClass('helen-checkout-form-parent-cart');
							Step(CART);
							$("html, body").animate({'scrollTop': 0}, 150);

							$classic.find('.helen-checkout-form-input').val(/** @type {string} */ (data['formsubmissionid']));
							$classic.find('.helen-checkout-classic-form').trigger('reset');
							$classic.find('.helen-checkout-product-select').trigger('change');

							setTimeout(function () {
								$Controls.removeAttr('disabled');
								l.stop();
                            });

                            gtm(':helen.checkout.classicquote.success');
						},
						error: function (_, /** Object<string,*> */ resp) {
							$Controls.removeAttr('disabled');
							l.stop();
							const FormID = /** @type {string} */ (resp['formsubmissionid']);
							if (!strempty(FormID)) {
								$classic.find('.helen-checkout-form-input').val(FormID);
                            }

                            gtm(':helen.checkout.classicquote.error');
						}
					});
                });

                const $checkoutPaymentOptionRadios = $checkout.find('input[name="helen-checkout-payment-option"]');
                const $checkoutPaymentOptionDetails = $checkout.find('.helen-checkout-payment-option-details');
                $checkoutPaymentOptionRadios.on('click', /** @this {Element} */ function () {
                    const $this = $(this);
                    const $d = $checkoutPaymentOptionDetails.filter(`[data-payment-option-type-id=${$this.val()}]`);

                    $checkout.find('[data-payment-option-type-id]').addClass('d-none').find('input[required]').removeAttr('required');

                    $checkoutPaymentOptionDetails.not($d).addClass('d-none');
                    $d.removeClass('d-none').find('input:not([type="file"]),select').attr('required', true);
                });

                if (window['paypal']) {
                    try {
                        paypal.Buttons({
                            'style': {
                                'shape': 'rect',
                                'color': 'gold',
                                'layout': 'horizontal',
                                'label': 'paypal',
                                'tagline': false,
                            },
                            'createOrder': function (_, /** Object<string,*> */ actions) {
                                $checkout.find('.helen-checkout-confirm-purchase-button').attr('disabled', true);

                                $checkout.
                                    find('.helen-checkout-paypal-radio-parent').removeClass('pl-1 mt-1').addClass('custom-control custom-radio').
                                    find('.custom-control-input').removeClass('d-none').end().
                                    find('label').addClass('custom-control-label').end().
                                    find('>hr').remove();

                                $checkout.find('.helen-checkout-paypal-radio-parent .custom-control-input').prop('checked', true).trigger('click');

                                return /** @type {function(*):*} */(actions['order']['create'])({
                                    'purchase_units': [{
                                        'amount': {
                                            'value': String(Big(Total).round(2)),
                                        },
                                    }],
                                    'intent': 'AUTHORIZE',
                                    'commit': false,
                                    'application_context': {
                                        'shipping_preference': 'NO_SHIPPING',
                                    },
                                });
                            },
                            'onApprove': function(/** Object<string,*> */ data, /** Object<string,*> */ actions) {
                                const fn = /** @type {function():*} */(actions['order']['authorize']);
                                const p = /** @type {Promise} */(fn());
                                const ret = p.then(function (/** Object<string,*> */ details) {
                                    $checkout.find('.helen-checkout-confirm-purchase-button').attr('disabled', false);
                                    $checkout.find('.helen-checkout-paypal-authorized').removeClass('d-none');
                                    paypalAuthID = /** @type {string} */(details['purchase_units'][0]['payments']['authorizations'][0]['id']);
                                });
                                return ret;
                            },
                            'onCancel': function () {
                                $checkout.find('.helen-checkout-confirm-purchase-button').attr('disabled', false);
                            },
                            'onError': function () {
                                $checkout.find('.helen-checkout-confirm-purchase-button').attr('disabled', false);
                            },
                        }).render(`#${$checkout.find('.helen-checkout-paypal-button-container').attr('id')}`);
                    } catch (_) {
                        $checkout.find('.helen-checkout-confirm-purchase-button').attr('disabled', false);
                    }
                }

                $checkout.
                    find('.helen-checkout-paypal-radio-parent').removeClass('custom-control custom-radio').
                    find('.custom-control-input').addClass('d-none').end().
                    find('label').removeClass('custom-control-label').end().
                    prepend('<hr>');

			});

			if (!LoadingCheckoutLibs) {
				LoadingCheckoutLibs = true;

				const js = /** @type {Array<string>} */ (data['js']);
				const css = /** @type {Array<string>} */ (data['css']);

				let loaded = 0;
				const libCount = js.length + css.length;
				const checkLoaded = function () {
					loaded++;
					if (loaded === libCount) {
						$(document).trigger(':helen.checkout.loaded');
					}
				};
				let i = 0;
				const nextJS = function () {
					const fn = function () {
						checkLoaded();
						i++ < js.length && nextJS();
					};
					if ($('script[src="'+js[i]+'"]').length === 0) {
						const $e = $('<script>');
						$('body').append($e);
						$e.on('load', function () {
							fn();
						}).attr('src', js[i]);
					} else {
						fn();
					}
				};
				nextJS();

				for (let i = 0; i < css.length; i++) {
					if ($('link[rel="stylesheet"][href="'+css[i]+'"]').length === 0) {
						const $e = $('<link>');
						$('head').append($e);
						$e.on('load', function () {
							checkLoaded();
						}).attr({
							'href': css[i],
							'rel': 'stylesheet'
						});
					} else {
						checkLoaded();
					}
				}
            }
		}
	});
});
